/* eslint-disable @typescript-eslint/no-shadow */
import {
  ADD_PATIENT_ALLERGY_SUCCESS as ADD_PATIENT_ALLERGY_SUCCESS_WAITING_ROOM,
  DELETE_PATIENT_ALLERGY_SUCCESS as DELETE_PATIENT_ALLERGY_SUCCESS_WAITING_ROOM,
  GET_VISIT_INFO_SUCCESS,
  GET_VISIT_PATIENT_CHART_SUCCESS,
  SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  UPDATE_ICD_CODES_SUCCESS as IN_VISIT_UPDATE_ICD_CODES_SUCCESS,
} from '../waitingRoom/WaitingRoomConstants'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import { apiErrorCodes, text } from '../../pages/charts/Constants'
import {
  ADD_ALERT,
  ADD_ALERT_ERROR,
  ADD_ALERT_SUCCESS,
  ADD_MEDIA_FILE,
  ADD_MEDIA_FILE_ERROR,
  ADD_MEDIA_FILE_SUCCESS,
  ADD_PATIENT_ALLERGY,
  ADD_PATIENT_ALLERGY_ERROR,
  ADD_PATIENT_ALLERGY_SUCCESS,
  CHECK_PHONE,
  CHECK_PHONE_ERROR,
  CHECK_PHONE_SUCCESS,
  CLEAR_PAST_VISIT_INFO_DATA,
  CLEAR_PATIENT_CHART,
  CLEAR_PATIENT_CHART_TREAT_LINK,
  CLEAR_PATIENT_DATA,
  CLEAR_PATIENT_LIST,
  COMPLETE_VISIT,
  COMPLETE_VISIT_ERROR,
  COMPLETE_VISIT_SUCCESS,
  DELETE_ALERT,
  DELETE_ALERT_ERROR,
  DELETE_ALERT_SUCCESS,
  DELETE_PATIENT_ALLERGY,
  DELETE_PATIENT_ALLERGY_ERROR,
  DELETE_PATIENT_ALLERGY_FROM_STORAGE,
  DELETE_PATIENT_ALLERGY_SUCCESS,
  DROP_ERROR,
  EDIT_ALERT,
  EDIT_ALERT_ERROR,
  EDIT_ALERT_SUCCESS,
  GET_ALERTS,
  GET_ALERTS_ERROR,
  GET_ALERTS_SUCCESS,
  GET_INTAKE_FORM,
  GET_INTAKE_FORM_ERROR,
  GET_INTAKE_FORM_SUCCESS,
  GET_MEDIA_FILES,
  GET_MEDIA_FILES_ERROR,
  GET_MEDIA_FILES_SUCCESS,
  GET_PAST_VISIT_INFO,
  GET_PAST_VISIT_INFO_ERROR,
  GET_PAST_VISIT_INFO_SUCCESS,
  GET_PAST_VISIT_TREAT_LINK,
  GET_PAST_VISIT_TREAT_LINK_ERROR,
  GET_PAST_VISIT_TREAT_LINK_SUCCESS,
  GET_PATIENT_CREDIT_CARDS_SUCCESS,
  GET_PATIENT_INTAKE_FORMS,
  GET_PATIENT_INTAKE_FORMS_ERROR,
  GET_PATIENT_INTAKE_FORMS_SUCCESS,
  GET_PATIENT_PAST_VISITS,
  GET_PATIENT_PAST_VISITS_ERROR,
  GET_PATIENT_PAST_VISITS_SUCCESS,
  GET_PATIENT_TREAT_LINK,
  GET_PATIENT_TREAT_LINK_ERROR,
  GET_PATIENT_TREAT_LINK_SUCCESS,
  GET_PATIENT_UPCOMING_VISITS,
  GET_PATIENT_UPCOMING_VISITS_ERROR,
  GET_PATIENT_UPCOMING_VISITS_SUCCESS,
  GET_PATIENTS_CHART,
  GET_PATIENTS_CHART_ERROR,
  GET_PATIENTS_CHART_SUCCESS,
  GET_PATIENTS_LIST,
  GET_PATIENTS_LIST_ERROR,
  GET_PATIENTS_LIST_SUCCESS,
  GET_PRESCRIPTIONS,
  GET_PRESCRIPTIONS_ERROR,
  GET_PRESCRIPTIONS_SUCCESS,
  MARK_ALL_USER_ALERTS_AS_READ,
  MARK_ALL_USER_ALERTS_AS_READ_ERROR,
  MARK_ALL_USER_ALERTS_AS_READ_SUCCESS,
  RESET_IS_ADDED_ALLERGY_STATUS,
  RESET_IS_DELETED_ALLERGY_STATUS,
  RESET_SEARCH_PHARMACY_LIST,
  SAVE_ACCOUNT_INFO,
  SAVE_ACCOUNT_INFO_ERROR,
  SAVE_ACCOUNT_INFO_SUCCESS,
  SAVE_GENERAL_INFO,
  SAVE_GENERAL_INFO_ERROR,
  SAVE_GENERAL_INFO_SUCCESS,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR,
  SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS,
  SAVE_VISIT_NOTES_ADDENDUM,
  SAVE_VISIT_NOTES_ADDENDUM_ERROR,
  SAVE_VISIT_NOTES_ADDENDUM_SUCCESS,
  SEARCH_FOR_ICD_CODES,
  SEARCH_FOR_ICD_CODES_ERROR,
  SEARCH_FOR_ICD_CODES_SUCCESS,
  SEARCH_PHARMACIES,
  SEARCH_PHARMACIES_ERROR,
  SEARCH_PHARMACIES_SUCCESS,
  SET_ALLERGY_NAME_ERROR,
  SET_ALLERGY_SEVERITY_ERROR,
  SET_ERROR,
  SET_ICD_CODES_UPDATE_SUCCESS,
  SET_IS_ACCOUNT_INFO_UPDATED_SUCCESS,
  SET_IS_CHANGED_VISIT_STATUS_SUCCESS,
  SET_IS_NEED_TO_UPDATE_PAST_VISITS,
  SET_IS_NOTE_ADDENDUM_SUCCESS_ADDED,
  SET_IS_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS_ADDED,
  SET_IS_PHARMACY_SEARCHING_DONE,
  SET_IS_PHONE_CORRECT,
  SET_MEDIA_FILE_TAGS,
  SET_MEDIA_FILE_TAGS_ERROR,
  SET_MEDIA_FILE_TAGS_SUCCESS,
  SET_PAST_VISIT_TREAT_LINK,
  SET_PATIENT_HAS_ALLERGIES,
  SET_PATIENT_HAS_ALLERGIES_ERROR,
  SET_PATIENT_HAS_ALLERGIES_SUCCESS,
  SET_PATIENT_HAS_NO_ALLERGIES,
  SET_PATIENT_HAS_NO_ALLERGIES_ERROR,
  SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS,
  SET_PATIENT_ID,
  SET_PATIENT_ID_FOR_RESET_MEDIA_FILES,
  SET_PATIENT_INSTRUCTION,
  SET_UPCOMING_VISIT_NOTE,
  SET_VISIT_PROVIDER,
  UNRESOLVE_VISIT,
  UNRESOLVE_VISIT_ERROR,
  UNRESOLVE_VISIT_SUCCESS,
  UPDATE_ICD_CODES,
  UPDATE_ICD_CODES_ERROR,
  UPDATE_ICD_CODES_SUCCESS,
} from './ChartsConstants'
import { ALERTS_SECTIONS_EMPTY_TEXT, FORBIDDEN_ERROR, MESSAGE_NOT_VALID_ERROR } from '../../utils/constants'

import { LOGOUT } from '../auth/AuthConstants'
import {
  GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS,
  SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS,
} from '../file-pop-up/FilePopUpConstants'
import { client } from 'api/components/queryClient'
import { getGetPatientsPatientIdQueryKey } from 'api/generated/patient/patient'

const FILE_FORMATS = '.pdf; .doc; .docx; .jpg; .jpeg; .png; .bmp'

const initialState = {
  loading: false,
  checkPhoneInProgress: false,
  error: '',
  chartPatientsList: [],
  lastListIncrease: 20,
  patientInfo: {},
  patientPrescriptionsList: [],
  isAllergyDeletedSuccess: false,
  isAllergyAddedSuccess: false,
  allergyNameError: '',
  allergySeverityError: '',
  isAllergiesRequestFinished: false,
  alerts: [],
  alertAdded: false,
  getAlertsSuccess: false,
  deleteAlertsSuccess: false,
  patientTreatLink: '',
  pastVisits: [],
  upcomingVisits: [],
  intakeForms: [],
  intakeForm: {},
  isPhoneCorrect: false,
  checkedPhoneNumber: '',
  patientId: null,
  visitInfo: {},
  isChangedVisitStatusSuccess: false,
  pastVisitTreatLink: '',
  foundPharmaciesCollection: null,
  isPharmacySearchingDone: false,
  isAccountInfoUpdatedSuccess: false,
  isNoteAddendumSuccessfullyAdded: false,
  isPatientInstructionsAddendumSuccessfullyAdded: false,
  icdCodesSearchResults: {},
  visitICDCodes: [],
  isPatientChartListWasCleared: false,
  icdCodesUpdatedSuccess: false,
  alertsEmptyMsg: '',
  patientIdForResetMediaFiles: null,
  isNeedToUpdatePastVisits: false,
  paintChartDataLoading: false,
  /**
   * Set to a patient id when a save the server already accepted could not be merged into
   * `patientInfo` because no chart is cached for that patient. Without it the miss path is
   * byte-identical to the applied path, so `ChartListener` closes the edit form as though
   * the chart now shows the new values while it silently still shows the old ones.
   * `ChartListener` consumes this by re-fetching the chart. It does not clear the field —
   * it does not need to. Both writers above are the same two actions the listener reacts
   * to, and the reducer runs before the listener effect, so every read sees the verdict
   * for the action being handled rather than a leftover from an earlier one.
   */
  patientChartNeedsRefetch: null,
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
const savePatientInfo = (patientId, payload) => {
  const patientQueryKey = getGetPatientsPatientIdQueryKey(patientId)
  client.setQueryData(patientQueryKey, payload)
}

export default function chartsReducer(state = initialState, action = { type: '' }) {
  switch (action.type) {
    case ADD_ALERT:
    case DELETE_ALERT:
    case MARK_ALL_USER_ALERTS_AS_READ:
    case EDIT_ALERT:
    case GET_PATIENTS_LIST:
    case GET_MEDIA_FILES:
    case ADD_MEDIA_FILE:
    case GET_PRESCRIPTIONS:
    case ADD_PATIENT_ALLERGY:
    case DELETE_PATIENT_ALLERGY:
    case GET_PATIENT_TREAT_LINK:
    case GET_PATIENT_PAST_VISITS:
    case GET_PATIENT_UPCOMING_VISITS:
    case GET_PATIENT_INTAKE_FORMS:
    case SAVE_GENERAL_INFO:
    case SAVE_ACCOUNT_INFO:
    case SET_MEDIA_FILE_TAGS:
    case GET_ALERTS:
    case GET_PAST_VISIT_TREAT_LINK:
    case GET_INTAKE_FORM:
    case SET_PATIENT_HAS_ALLERGIES:
    case SET_PATIENT_HAS_NO_ALLERGIES:
      return {
        ...state,
        loading: true,
      }

    case CHECK_PHONE: {
      console.log('runl')
      return {
        ...state,
        loading: true,
        checkPhoneInProgress: true,
      }
    }
    case GET_PATIENTS_CHART:
      return {
        ...state,
        paintChartDataLoading: true,
        loading: true,
      }
    case SEARCH_FOR_ICD_CODES:
    case UPDATE_ICD_CODES:
    case SAVE_PATIENT_INSTRUCTIONS_ADDENDUM:
    case SAVE_VISIT_NOTES_ADDENDUM:
    case COMPLETE_VISIT:
    case UNRESOLVE_VISIT:
    case GET_PAST_VISIT_INFO: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.extraData.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`] = {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          ...cloneVisit[`${action.extraData.visitId}`],
          loading: true,
        }
      } else {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`] = { loading: true }
      }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visitInfo: { ...cloneVisit },
      }
    }
    case SEARCH_PHARMACIES:
      return {
        ...state,
        error: '',
        loading: true,
        foundPharmaciesCollection: null,
        isPharmacySearchingDone: false,
      }
    case CLEAR_PATIENT_LIST:
      return {
        ...state,
        chartPatientsList: [],
        lastListIncrease: 20,
        isPatientChartListWasCleared: true,
      }
    case SEARCH_FOR_ICD_CODES_SUCCESS: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      cloneVisit[`${action.extraData.visitId}`] = {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        ...cloneVisit[`${action.extraData.visitId}`],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        icdCodesSearchResults: { results: action.payload, searchId: action.extraData.searchId },
        loading: false,
      }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visitInfo: { ...cloneVisit },
        loading: false,
      }
    }
    case IN_VISIT_UPDATE_ICD_CODES_SUCCESS:
    case UPDATE_ICD_CODES_SUCCESS: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      cloneVisit[`${action.extraData.visitId}`] = {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        ...cloneVisit[`${action.extraData.visitId}`],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitICDCodes: action.extraData.codes,
        icdCodesUpdatedSuccess: true,
        loading: false,
      }
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visitInfo: { ...cloneVisit },
      }
    }
    case SET_ICD_CODES_UPDATE_SUCCESS:
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      cloneVisit[`${action.payload.visitId}`] = {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        ...cloneVisit[`${action.payload.visitId}`],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        icdCodesUpdatedSuccess: action.payload.value,
      }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visitInfo: { ...cloneVisit },
      }
    case SAVE_GENERAL_INFO_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].MaritalStatus = action.extraData.generalInfo.MaritalStatus
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].GenderIdentity = action.extraData.generalInfo.GenderIdentity
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].RacialBackground = action.extraData.generalInfo.RacialBackground
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].HeightInches = action.extraData.generalInfo.HeightInches
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].WeightPounds = action.extraData.generalInfo.WeightPounds
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
          patientChartNeedsRefetch: null,
        }
      }
      // No cached chart to merge the saved values into. The write itself already
      // succeeded on the server, so this is not a failure — but it is also not applied,
      // and the chart cannot show the new values until it is re-fetched.
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientChartNeedsRefetch: `${action.extraData.patientId}`,
      }
    }
    case SAVE_ACCOUNT_INFO_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].PreferredName = action.extraData.accountInfo.PreferredName
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].EmergencyContact = action.extraData.accountInfo.EmergencyContact
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].BirthDate = action.extraData.accountInfo.BirthDate
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].Pharmacy =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.extraData.pharmacyInfo || clonePatient[`${action.extraData.patientId}`].Pharmacy
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
          isAccountInfoUpdatedSuccess: true,
          patientChartNeedsRefetch: null,
        }
      }
      // No cached chart to merge the saved values into. The write itself already
      // succeeded on the server, so this is not a failure — but it is also not applied,
      // and the chart cannot show the new values until it is re-fetched.
      return {
        ...state,
        loading: false,
        isAccountInfoUpdatedSuccess: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientChartNeedsRefetch: `${action.extraData.patientId}`,
      }
    }
    case CLEAR_PATIENT_DATA: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      if (clonePatient?.[`${action.payload}`]) {
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.payload}`].intakeForms = []
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.payload}`].pastVisits = []
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.payload}`].upcomingVisits = []
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.payload}`].patientPrescriptionsList = []
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.payload}`].creditCards = undefined
      }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        patientInfo: { ...clonePatient },
      }
    }
    case CLEAR_PATIENT_CHART_TREAT_LINK: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.payload}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.payload}`].patientTreatLink = null
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case SAVE_VISIT_NOTES_ADDENDUM_SUCCESS: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.extraData.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`].isNoteAddendumSuccessfullyAdded = true

        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (action.extraData.isWithoutSaving) {
          return {
            ...state,
            // loading
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            visitInfo: { ...cloneVisit },
          }
        }
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`] = {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          ...cloneVisit[`${action.extraData.visitId}`],
          isNoteAddendumSuccessfullyAdded: true,
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          Notes: [...cloneVisit[`${action.extraData.visitId}`].Notes, action.payload],
          loading: false,
        }

        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          visitInfo: { ...cloneVisit },
        }
      }
      return {
        ...state,
      }
    }
    case SET_IS_NOTE_ADDENDUM_SUCCESS_ADDED: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.payload.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.payload.visitId}`].isNoteAddendumSuccessfullyAdded = action.payload.newStatus
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          visitInfo: { ...cloneVisit },
        }
      }
      return {
        ...state,
      }
    }

    case SET_UPCOMING_VISIT_NOTE: {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const existingVisit = state.visitInfo[action.payload.visitId]
      if (!existingVisit) return state
      const updatedVisit = {
        ...existingVisit,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        Notes: action.payload.note ? [action.payload.note] : [],
      }

      return {
        ...state,
        visitInfo: {
          ...state.visitInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.visitId]: updatedVisit,
        },
      }
    }

    case SET_PATIENT_INSTRUCTION: {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const cloneVisit = { ...state.visitInfo }[action.payload.visitId]
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      cloneVisit.PatientInstructions = action.payload.instruction ? [action.payload.instruction] : []

      return {
        ...state,
        visitInfo: {
          ...state.visitInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.payload.visitId]: cloneVisit,
        },
      }
    }

    case SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.extraData.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`].isPatientInstructionsAddendumSuccessfullyAdded = true

        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (action.extraData.isWithoutSaving) {
          return {
            ...state,
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            visitInfo: { ...cloneVisit },
          }
        }
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`] = {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          ...cloneVisit[`${action.extraData.visitId}`],
          isPatientInstructionsAddendumSuccessfullyAdded: true,
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          PatientInstructions: [...cloneVisit[`${action.extraData.visitId}`].PatientInstructions, action.payload],
          loading: false,
        }

        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          visitInfo: { ...cloneVisit },
        }
      }
      return {
        ...state,
      }
    }

    case SET_IS_PATIENT_INSTRUCTIONS_ADDENDUM_SUCCESS_ADDED: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.payload.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.payload.visitId}`].isPatientInstructionsAddendumSuccessfullyAdded =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.newStatus
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          visitInfo: { ...cloneVisit },
        }
      }
      return {
        ...state,
      }
    }
    case SET_VISIT_PROVIDER: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.payload.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.payload.visitId}`].Provider = action.payload.provider
      } else {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.payload.visitId}`] = { Provider: action.payload.provider }
      }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visitInfo: { ...cloneVisit },
      }
    }

    case GET_PATIENT_TREAT_LINK_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].patientTreatLink = action.payload.ProfileUrl
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case GET_PATIENT_PAST_VISITS_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].pastVisits = action.payload
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          pastVisits: action.payload,
          loading: false,
        }
      }
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        pastVisits: action.payload,
      }
    }
    case GET_PATIENT_UPCOMING_VISITS_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].upcomingVisits = action.payload
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          upcomingVisits: action.payload,
          loading: false,
        }
      }
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        upcomingVisits: action.payload,
      }
    }
    case GET_PATIENT_INTAKE_FORMS_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].intakeForms = action.payload
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case GET_ALERTS_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].alerts = action.payload
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
          getAlertsSuccess: true,
          deleteAlertsSuccess: false,
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case SET_VISIT_PATIENT_HAS_ALLERGIES_SUCCESS:
    case SET_PATIENT_HAS_ALLERGIES_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        return {
          ...state,
          loading: false,
          patientInfo: {
            ...state.patientInfo,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            [action.extraData.patientId]: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.patientInfo[action.extraData.patientId],
              AllergyCollection: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId].AllergyCollection,
                HasNoAllergyConfirmation: false,
              },
            },
          },
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case SET_VISIT_PATIENT_HAS_NO_ALLERGIES_SUCCESS:
    case SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        return {
          ...state,
          loading: false,
          patientInfo: {
            ...state.patientInfo,
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            [action.extraData.patientId]: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.patientInfo[action.extraData.patientId],
              AllergyCollection: { Allergies: [], HasNoAllergyConfirmation: true },
            },
          },
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case GET_VISIT_PATIENT_CHART_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`] = { ...action.payload }
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case GET_PATIENTS_CHART_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      clonePatient[`${action.extraData.patientId}`] = {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        ...clonePatient[`${action.extraData.patientId}`],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        ...action.payload,
      }

      const updatedChartPatientsList = JSON.parse(JSON.stringify(state.chartPatientsList))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedChartPatientsList.forEach((patient, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (patient.PatientId === action.extraData.patientId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.DrugScreen = action.payload.DrugScreen
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.IdentityVerification = action.payload.IdentityVerification
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedChartPatientsList[index] = patient
        }
      })
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      savePatientInfo(action.extraData.patientId, action.payload)

      return {
        ...state,
        chartPatientsList: updatedChartPatientsList,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        patientInfo: { ...clonePatient },
        loading: false,
        paintChartDataLoading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        alertsEmptyMsg: action?.payload?.AlertSummary?.Count === 0 ? ALERTS_SECTIONS_EMPTY_TEXT : '',
      }
    }
    case GET_MEDIA_FILES_SUCCESS: {
      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            mediaFiles: action.payload,
          },
        },
      }
    }
    case GET_PATIENT_DRUG_SCREEN_INFO_SUCCESS: {
      const updatedChartPatientsList = JSON.parse(JSON.stringify(state.chartPatientsList))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedChartPatientsList.forEach((patient, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (patient.PatientId === action.extraData.patientId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.DrugScreen = action.payload.DrugScreen
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          patient.IdentityVerification = action.payload.IdentityVerification
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedChartPatientsList[index] = patient
        }
      })
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const hasPatientInfo = state.patientInfo[action.extraData.patientId]
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      savePatientInfo(action.extraData.patientId, action.payload)
      return {
        ...state,
        chartPatientsList: updatedChartPatientsList,
        patientInfo:
          hasPatientInfo ?
            {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                DrugScreen: action.payload.DrugScreen,
                // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                IdentityVerification: action.payload.IdentityVerification,
              },
            }
          : state.patientInfo,
      }
    }
    case SET_MEDIA_FILE_TAGS_SUCCESS:
    case SET_FILE_POP_UP_MEDIA_FILE_TAGS_SUCCESS:
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const hasPatientInfo = state.patientInfo[action.extraData.patientId]
      const updatedMediaFiles = JSON.parse(
        // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
        JSON.stringify(state.patientInfo[action.extraData.patientId]?.mediaFiles || []),
      )
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      updatedMediaFiles.forEach((file, index) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (file.FileId === action.payload.data.FileId) {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          file = action.payload.data
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          updatedMediaFiles[index] = file
        }
      })
      return {
        ...state,
        loading: action.type === SET_MEDIA_FILE_TAGS_SUCCESS ? false : state.loading,
        patientInfo:
          hasPatientInfo ?
            {
              ...state.patientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              [action.extraData.patientId]: {
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...state.patientInfo[action.extraData.patientId],
                // @ts-expect-error TS2488 -- MIGRATION: not approved, fix when encountered
                mediaFiles: [...updatedMediaFiles],
              },
            }
          : state.patientInfo,
      }
    case GET_PATIENT_CREDIT_CARDS_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { patientId } = action.extraData
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const existingPatientInfo = state.patientInfo[patientId]
      if (existingPatientInfo) {
        return {
          ...state,
          loading: false,
          patientInfo: {
            ...state.patientInfo,
            [patientId]: {
              ...existingPatientInfo,
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              creditCards: action.payload,
            },
          },
        }
      }
      return { ...state }
    }
    case ADD_MEDIA_FILE_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { patientId } = action.extraData
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const newMediaFile = action.payload
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const existingPatientInfo = state.patientInfo[patientId] || {}
      const existingMediaFiles = existingPatientInfo.mediaFiles || []

      return {
        ...state,
        loading: false,
        patientInfo: {
          ...state.patientInfo,
          [patientId]: {
            ...existingPatientInfo,
            MediaFileSummary: {
              Count: (existingPatientInfo.MediaFileSummary?.Count || 0) + 1,
            },
            mediaFiles: [newMediaFile, ...existingMediaFiles],
          },
        },
      }
    }
    case CHECK_PHONE_SUCCESS:
      return {
        ...state,
        loading: false,
        isPhoneCorrect: true,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        checkedPhoneNumber: action.extraData.number,
        checkPhoneInProgress: false,
      }
    case SEARCH_PHARMACIES_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        foundPharmaciesCollection: action.payload,
        isPharmacySearchingDone: true,
      }
    case SET_IS_NEED_TO_UPDATE_PAST_VISITS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isNeedToUpdatePastVisits: action.payload,
      }
    case COMPLETE_VISIT_SUCCESS:
    case UNRESOLVE_VISIT_SUCCESS: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.extraData.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`].isChangedVisitStatusSuccess = true
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`].loading = false

        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          visitInfo: { ...cloneVisit },
          isNeedToUpdatePastVisits: true,
        }
      }
      return {
        ...state,
        loading: false,
        isNeedToUpdatePastVisits: true,
      }
    }
    case ADD_ALERT_SUCCESS:
    case EDIT_ALERT_SUCCESS:
    case DELETE_ALERT_SUCCESS:
      return {
        ...state,
        loading: false,
      }
    case SET_PATIENT_ID_FOR_RESET_MEDIA_FILES:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientIdForResetMediaFiles: action.payload,
      }
    case SET_IS_CHANGED_VISIT_STATUS_SUCCESS: {
      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (cloneVisit[`${action.payload.visitId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.payload.visitId}`].isChangedVisitStatusSuccess = action.payload.newStatus
      }
      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visitInfo: { ...cloneVisit },
      }
    }
    case SET_IS_ACCOUNT_INFO_UPDATED_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isAccountInfoUpdatedSuccess: action.payload,
      }
    case GET_PATIENTS_LIST_SUCCESS:
      let chartPatientsList

      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (state.chartPatientsList[0]?.Email === action.payload[0]?.Email) {
        chartPatientsList = [...state.chartPatientsList]
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      } else if (action.extraData.isUpdatePatientsList) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        chartPatientsList = action.payload
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        chartPatientsList = [...state.chartPatientsList, ...action.payload]
      }

      return {
        ...state,
        chartPatientsList,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        lastListIncrease: action.payload?.length,
        loading: false,
        isPatientChartListWasCleared: false,
      }
    case GET_VISIT_INFO_SUCCESS:
    case GET_PAST_VISIT_INFO_SUCCESS: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      action.payload.Notes?.sort((a, b) => (a.IsAddendum ? 1 : -1))

      const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo || {}))

      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      cloneVisit[`${action.extraData.visitId}`] = {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        ...cloneVisit[`${action.extraData.visitId}`],
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        ...action.payload,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        visitICDCodes: action.payload.IcdCodes,
      }

      return {
        ...state,
        // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
        visitInfo: { ...cloneVisit },
        loading: false,
      }
    }
    case GET_PAST_VISIT_TREAT_LINK_SUCCESS:
      return {
        ...state,
        pastVisitTreatLink: {
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          ...state?.pastVisitTreatLink,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.visitId]: action.payload,
        },
        loading: false,
      }
    case GET_PRESCRIPTIONS_SUCCESS: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))

      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      if (clonePatient[`${action.extraData.patientId}`]) {
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`].patientPrescriptionsList = action.payload
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          loading: false,
        }
      }
      return {
        ...state,
        loading: false,
      }
    }
    case ADD_PATIENT_ALLERGY_SUCCESS:
    case ADD_PATIENT_ALLERGY_SUCCESS_WAITING_ROOM: {
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      const cachedPatient = state.patientInfo[action.extraData.patientId]
      if (!cachedPatient) {
        return {
          ...state,
        }
      }
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            ...cachedPatient,
            AllergyCollection: {
              ...cachedPatient.AllergyCollection,
              // `?.Allergies ?? []` and not a bare spread: a cached patient whose chart carries
              // no AllergyCollection still reaches this branch, and a throw here aborts the
              // whole dispatch — including WaitingRoomReducer, which handles this same action
              // and would otherwise never apply it.
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              Allergies: [...(cachedPatient.AllergyCollection?.Allergies ?? []), action.payload],
              HasNoAllergyConfirmation: false,
            },
          },
        },
        loading: false,
      }
    }
    case GET_INTAKE_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        intakeForm: action.payload,
      }
    case DELETE_PATIENT_ALLERGY_FROM_STORAGE: {
      const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))

      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      const cachedPatient = clonePatient[`${action.extraData.patientId}`]
      // A cached patient whose chart carries no AllergyCollection still reaches this branch,
      // and reading `.Allergies` off it throws — which aborts the whole dispatch, including
      // WaitingRoomReducer, which handles this same action and would otherwise never apply
      // it. With nothing cached to filter there is also nothing to delete, so leave the
      // state alone rather than writing an empty collection the server never confirmed.
      if (cachedPatient?.AllergyCollection?.Allergies) {
        cachedPatient.AllergyCollection.Allergies = cachedPatient.AllergyCollection.Allergies.filter(
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          (allergy) => allergy.AllergyId !== action.extraData.allergyId,
        )
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
        }
      }
      return {
        ...state,
      }
    }
    case DELETE_PATIENT_ALLERGY_SUCCESS:
    case DELETE_PATIENT_ALLERGY_SUCCESS_WAITING_ROOM:
      // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
      if (!state.patientInfo[action.extraData.patientId]) {
        return {
          ...state,
        }
      }
      return {
        ...state,
        patientInfo: {
          ...state.patientInfo,
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          [action.extraData.patientId]: {
            // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
            ...state.patientInfo[action.extraData.patientId],
            AllergyCollection: {
              // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
              ...state.patientInfo[action.extraData.patientId].AllergyCollection,
              // `?.Allergies ?? []`, same reason as the ADD branch above: a cached patient
              // whose chart carries no AllergyCollection still reaches here, and a throw
              // aborts the whole dispatch — including WaitingRoomReducer, which handles
              // this same action and would otherwise never apply it.
              Allergies: [
                // @ts-expect-error TS7053 -- MIGRATION: not approved, fix when encountered
                ...(state.patientInfo[action.extraData.patientId].AllergyCollection?.Allergies ?? []).filter(
                  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                  (allergy) => allergy.AllergyId !== action.extraData.allergyId,
                ),
              ],
            },
          },
        },
        loading: false,
      }
    case RESET_IS_ADDED_ALLERGY_STATUS:
      return {
        ...state,
        isAllergyAddedSuccess: false,
        isAllergiesRequestFinished: false,
      }
    case RESET_IS_DELETED_ALLERGY_STATUS:
      return {
        ...state,
        isAllergyDeletedSuccess: false,
      }
    case MARK_ALL_USER_ALERTS_AS_READ_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case DROP_ERROR:
      return {
        ...state,
        error: undefined,
      }

    case SET_ERROR:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.patientId) {
        const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))

        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (clonePatient[`${action.extraData.patientId}`]) {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          clonePatient[`${action.extraData.patientId}`].error = action.payload
          return {
            ...state,
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            patientInfo: { ...clonePatient },
            allergyNameError: '',
            allergySeverityError: '',
          }
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData.visitId) {
        const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))

        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (cloneVisit[`${action.extraData.visitId}`]) {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          cloneVisit[`${action.extraData.visitId}`].error = action.payload
          return {
            ...state,
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            visitInfo: { ...cloneVisit },
            allergyNameError: '',
            allergySeverityError: '',
          }
        }
      }
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
        allergyNameError: '',
        allergySeverityError: '',
      }
    case SET_ALLERGY_NAME_ERROR:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        allergyNameError: action.payload,
      }
    case SET_PAST_VISIT_TREAT_LINK:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        pastVisitTreatLink: action.payload,
      }
    case SET_PATIENT_ID:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        patientId: action.payload,
      }
    case SET_ALLERGY_SEVERITY_ERROR:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        allergySeverityError: action.payload,
      }
    case CLEAR_PATIENT_CHART:
      return {
        ...state,
        loading: false,
        getAlertsSuccess: false,
        patientTreatLink: '',
        pastVisits: [],
        intakeForms: [],
        alerts: [],
        patientPrescriptionsList: [],
      }
    case CLEAR_PAST_VISIT_INFO_DATA:
      return {
        ...state,
      }
    case RESET_SEARCH_PHARMACY_LIST:
      return {
        ...state,
        foundPharmaciesCollection: null,
      }
    case SET_IS_PHONE_CORRECT:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { isCorrect, number } = action.payload

      return {
        ...state,
        isPhoneCorrect: isCorrect,
        checkedPhoneNumber: number,
      }
    case SET_IS_PHARMACY_SEARCHING_DONE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isPharmacySearchingDone: action.payload,
      }
    case CHECK_PHONE_ERROR: {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      const { Data, ErrorCode, number } = action.payload
      if (ErrorCode === 'ThirdPartyError') {
        const { ErrorCode, ErrorMessage } = Data
        const message = `${ErrorCode} - ${ErrorMessage}`
        return {
          ...state,
          isPhoneCorrect: false,
          checkedPhoneNumber: number,
          error: message,
          loading: false,
          checkPhoneInProgress: false,
        }
      }
      return {
        ...state,
        isPhoneCorrect: false,
        checkedPhoneNumber: number,
        loading: false,
        checkPhoneInProgress: false,
      }
    }
    case GET_PATIENTS_LIST_ERROR:
    case GET_PATIENTS_CHART_ERROR:
    case GET_MEDIA_FILES_ERROR:
    case SET_MEDIA_FILE_TAGS_ERROR:
    case ADD_MEDIA_FILE_ERROR:
    case GET_PRESCRIPTIONS_ERROR:
    case DELETE_ALERT_ERROR:
    case ADD_PATIENT_ALLERGY_ERROR:
    case DELETE_PATIENT_ALLERGY_ERROR:
    case MARK_ALL_USER_ALERTS_AS_READ_ERROR:
    case ADD_ALERT_ERROR:
    case EDIT_ALERT_ERROR:
    case GET_ALERTS_ERROR:
    case GET_PATIENT_TREAT_LINK_ERROR:
    case GET_PATIENT_PAST_VISITS_ERROR:
    case GET_PATIENT_UPCOMING_VISITS_ERROR:
    case GET_PATIENT_INTAKE_FORMS_ERROR:
    case SAVE_GENERAL_INFO_ERROR:
    case SAVE_ACCOUNT_INFO_ERROR:
    case GET_PAST_VISIT_INFO_ERROR:
    case COMPLETE_VISIT_ERROR:
    case SAVE_PATIENT_INSTRUCTIONS_ADDENDUM_ERROR:
    case SAVE_VISIT_NOTES_ADDENDUM_ERROR:
    case UNRESOLVE_VISIT_ERROR:
    case GET_INTAKE_FORM_ERROR:
    case SEARCH_PHARMACIES_ERROR:
    case GET_PAST_VISIT_TREAT_LINK_ERROR:
    case UPDATE_ICD_CODES_ERROR:
    case SEARCH_FOR_ICD_CODES_ERROR:
    case SET_PATIENT_HAS_ALLERGIES_ERROR:
    case SET_PATIENT_HAS_NO_ALLERGIES_ERROR: {
      let message = ''
      let allergyNameErrorMessage = ''
      let allergySeverityErrorMessage = ''
      // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
      let defaultServerErrorMessage = ''
      let isAllergyAlreadyDeleted = false
      let isNotResetLoading = false
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        defaultServerErrorMessage = action.payload.UserFriendlyErrorCode ? action.payload : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'Network Error':
            message = getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION)
            break
          case 'CountNotValid':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Count')
            break
          case 'OffsetNotValid':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Offset')
            break
          case 'FileTagNotValid':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_VALID_VALUE, null, 'Tags')
            break
          case 'FileNotValid':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.INVALID_FILE_FORMAT, null, FILE_FORMATS)
            break
          case 'ThirdPartyError':
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            const { ErrorCode, ErrorMessage } = action.payload.Data
            message = `${ErrorCode} - ${ErrorMessage}`
            break
          case 'PatientNotFound':
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            if (action?.extraData?.patientId) {
              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
              action.extraData.patientId = undefined
            }
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Patient')
            break
          case 'FileNotFound':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'File')
            break
          case 'IntakeFormNotFound':
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'Intake form')
            break
          case apiErrorCodes.GenderIdentityNotValid:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.GENDER_IDENTITY)
            break
          case apiErrorCodes.PhoneNumberNotValid:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.PHONE_NUMBER)
            break
          case apiErrorCodes.MaritalStatusNotValid:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.MARITAL_STATUS)
            break
          case apiErrorCodes.RacialBackgroundNotValid:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.RACIAL_BACKGROUND)
            break
          case apiErrorCodes.HeightInchesNotValid:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, text.HEIGHT)
            break
          case apiErrorCodes.WeightPoundsNotValid:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, text.WEIGHT)
            break
          case 'AllergyNameNotUnique':
            isNotResetLoading = true
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            allergyNameErrorMessage = getUserFriendlyErrorMessage(errorCodes.ALLERGY_NAME_NOT_UNIQUE)
            break
          case 'AllergyNotFound':
            isAllergyAlreadyDeleted = true
            break
          case 'AllergyNameNotValid':
            isNotResetLoading = false
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            allergyNameErrorMessage = getUserFriendlyErrorMessage(errorCodes.ONLY_NUMBERS_AND_LETTERS_ALLOWED)
            break
          case MESSAGE_NOT_VALID_ERROR:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, 'alert message')
            break
          case apiErrorCodes.IcdCodeCountNotValid:
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            message = getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, text.ICD_CODE)
            break
          case FORBIDDEN_ERROR:
            message =
              action.type === EDIT_ALERT_ERROR || action.type === DELETE_ALERT_ERROR ?
                getUserFriendlyErrorMessage(errorCodes.FORBIDDEN_ACTION)
              : getUserFriendlyErrorMessage(errorCodes.VISIT_HAS_COMPLETED)
            break
          case 'PhoneNumberNotUnique':
            message = getUserFriendlyErrorMessage(errorCodes.PHONE_NOT_UNIQUE)
            break
          case 'AllergySeverityNotValid':
            isNotResetLoading = true
            message = getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS)
            allergySeverityErrorMessage = getUserFriendlyErrorMessage(
              errorCodes.NOT_VALID_VALUE,
              // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
              null,
              'Allergy Severity',
            )
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          case 'TreatCommunicationError':
            message = getUserFriendlyErrorMessage(errorCodes.TREAT_ERROR)
            break

          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            defaultServerErrorMessage = action.payload
            break
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData?.patientId) {
        const clonePatient = JSON.parse(JSON.stringify(state.patientInfo))
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (clonePatient[`${action.extraData.patientId}`]) {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          clonePatient[`${action.extraData.patientId}`].error = message
          return {
            ...state,
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            patientInfo: { ...clonePatient },
            allergyNameError: allergyNameErrorMessage,
            allergySeverityError: allergySeverityErrorMessage,
            loading: isNotResetLoading,
            defaultServerErrorMessage: '',
            isAllergyAddedSuccess: message,
            isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
            isAllergiesRequestFinished: isNotResetLoading,
            isPatientChartListWasCleared: false,
            paintChartDataLoading: false,
          }
        }
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        clonePatient[`${action.extraData.patientId}`] = { error: message }
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...clonePatient },
          allergyNameError: allergyNameErrorMessage,
          allergySeverityError: allergySeverityErrorMessage,
          loading: isNotResetLoading,
          defaultServerErrorMessage: '',
          isAllergyAddedSuccess: message,
          isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
          isAllergiesRequestFinished: isNotResetLoading,
          isPatientChartListWasCleared: false,
          paintChartDataLoading: false,
        }
      }
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.extraData?.visitId) {
        const cloneVisit = JSON.parse(JSON.stringify(state.visitInfo))

        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        if (cloneVisit[`${action.extraData.visitId}`]) {
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          cloneVisit[`${action.extraData.visitId}`].error = message
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          cloneVisit[`${action.extraData.visitId}`].loading = false
          return {
            ...state,
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            visitInfo: { ...cloneVisit },
            allergyNameError: allergyNameErrorMessage,
            allergySeverityError: allergySeverityErrorMessage,
            loading: isNotResetLoading,
            defaultServerErrorMessage: '',
            isAllergyAddedSuccess: message,
            isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
            isAllergiesRequestFinished: isNotResetLoading,
            isPatientChartListWasCleared: false,
            paintChartDataLoading: false,
          }
        }
        // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
        cloneVisit[`${action.extraData.visitId}`] = { error: message, loading: false }
        return {
          ...state,
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          patientInfo: { ...cloneVisit },
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          visitInfo: { ...cloneVisit },
          allergyNameError: allergyNameErrorMessage,
          allergySeverityError: allergySeverityErrorMessage,
          loading: isNotResetLoading,
          defaultServerErrorMessage: '',
          isAllergyAddedSuccess: message,
          isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
          isAllergiesRequestFinished: isNotResetLoading,
          isPatientChartListWasCleared: false,
          paintChartDataLoading: false,
        }
      }
      return {
        ...state,
        error: message,
        isChangedVisitStatusSuccess: false,
        allergyNameError: allergyNameErrorMessage,
        allergySeverityError: allergySeverityErrorMessage,
        loading: isNotResetLoading,
        defaultServerErrorMessage: '',
        isAllergyAddedSuccess: message,
        isAllergyDeletedSuccess: isAllergyAlreadyDeleted || message,
        isAllergiesRequestFinished: isNotResetLoading,
        isPatientChartListWasCleared: false,
        paintChartDataLoading: false,
      }
    }
    case LOGOUT:
      return { ...initialState }
    default: {
      return state
    }
  }
}
